import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function validateTransferAmount(walletBalance: string): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const invalidBalance = +walletBalance < +control.value;

    return invalidBalance ? { invalidBalance: { value: control.value } } : null;
  };
}

export function validateTransferMinAmount(walletBalance: string): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const invalidBalance = +walletBalance > +control.value;

    return invalidBalance ? { min: { value: control.value } } : null;
  };
}
